module.exports = __webpack_public_path__ + "static/assets/52403c7d9761336c543c8793bc2230ae.png";